import { db } from "@/firebaseConfig";

const drinksCollection = db.collection("drinks");

const saveDrink = async data => {
  drinksCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("Drink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateDrink = async (id, data) => {
  drinksCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("Drink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteDrink = async id => {
  drinksCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("Drink successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getDrinkById = async id => {
  return drinksCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getLastDrink = async () => {
  return drinksCollection
    .orderBy("updated_on", "desc")
    .limit(1)
    .get();
};

export {
  drinksCollection,
  saveDrink,
  updateDrink,
  deleteDrink,
  getDrinkById,
  getLastDrink
};
